import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { DnDAnswerOption } from '../interface';
import { AnswerOptionStatus } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

export interface IDnDOptionItemV2Props {
    option: DnDAnswerOption;
    onOptionSelect: (item: DnDAnswerOption) => void;
}

export function DnDOptionItemV2({
    option,
    onOptionSelect,
}: IDnDOptionItemV2Props): JSX.Element {
    const ref = useRef<HTMLDivElement>(null);
    const [options, setOptions] = useState<Record<string, unknown>>(null);

    useEffect(() => {
        const width: number = ref.current?.getBoundingClientRect().width;
        setOptions({
            width,
            minWidth: width,
        });
    }, []);

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => onOptionSelect({ ...option, options })}
            className={classNames('sl-dnd-options-v2__item', {
                selected: option?.status === AnswerOptionStatus.Selected,
            })}
        >
            <span>{option.text}</span>
        </div>
    );
}
